module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_018.png
// module id = 2365
// module chunks = 5